export default __webpack_public_path__ + "static/media/person-gray-icon.ba04b90e.svg";